<!-- Navbar -->
<nav class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent" id="elementNav">
    <div class="container-fluid">
        <div class="navbar-wrapper">
            <div class="navbar-minimize">
                <button id="minimizeSidebar" class="btn btn-icon btn-round" (click)="sideMenuService.changeMenu()">
          <i
            class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"
          ></i>
          <i
            class="
              nc-icon nc-minimal-left
              text-center
              visible-on-sidebar-regular
            "
          ></i>
        </button>
            </div>
            <div class="navbar-toggle">
                <button type="button" class="navbar-toggler" (click)="sideMenuService.navToggle()">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
            </div>
            <a class="navbar-brand" href="javascript:;"></a>
        </div>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation" (click)="sideMenuService.optionsToggle()" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation" id="elementButton">
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>
        <div class="collapse navbar-collapse justify-content-end" id="elementNavigation">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link btn-rotate" style="cursor: pointer">
                        <i class="fa fa-user" aria-hidden="true"></i>
                        <p>
                            <span class="d-md-block">{{ user.nome }}</span>
                        </p>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link btn-rotate" style="cursor: pointer">
                        <i class="fa fa-question-circle" aria-hidden="true"></i>
                        <p>
                            <span class="d-md-block">Ajuda</span>
                        </p>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link btn-rotate" (click)="logout()" style="cursor: pointer">
                        <i class="fa fa-sign-out" aria-hidden="true"></i>
                        <p>
                            <span class="d-lg-none d-md-block">Sair</span>
                        </p>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</nav>
<!-- End Navbar -->